<div id="jetco-container">
  <div class="page-header">
    <app-toolbar-options icon="house">
      <div class="d-flex flex-column" slot="start">
        <div class="page-title">Jetco</div>
      </div>
    </app-toolbar-options>
  </div>
  <div class="page-content" appanimatecss>
    <app-component-wrapper class="historical-graph-component" icon="" title="">
      <div class="d-flex flex-column" slot="start">
        <div class="header">
          <h3 class="mt-2 mb-0">What is JETCO?</h3>
        </div>
        <p>
          The Joint Electrical Training Council (JETCO) is CIRT's associated training fund. JETCO offers eligible
          employees, who complete training related to the electrical contracting industry, subsidies to assist with in
          the costs of completing these courses.
        </p>

        <div class="header">
          <h3 class="mt-2 mb-0">Eligibility Rules for Employees and Apprentices (excluding Group Training Apprentices)</h3>
        </div>
        <p>
          Course fees associated with training will be reimbursed where the employee completing the training program
          meets the following criteria:
        </p>
        <ul>
          <li>Employees with 6 consecutive monthly contributions into the JETCO training fund are eligible for a training subsidy of up to <strong>$500.00</strong> on approved courses per financial year.</li>
          <li>
            Once an employee receives 12 consecutive monthly contributions into the JETCO training fund, they are
            eligible for increased training subsidy as follows:
            <ul>
              <li>Where the employer contributes <strong>$5.00 per week</strong> into the training fund, the employee is eligible for a training subsidy of up to <strong>$1,200.00</strong> per financial year.</li>
              <li>Where the employer contributes <strong>$10.00 per week</strong> into the training fund, the employee is eligible for a training subsidy of up to <strong>$1,800.00</strong> per financial year.</li>
              <li>Where the employer contributes <strong>$15.00 per week</strong> into the training fund, the employee is eligible for a training subsidy of up to <strong>$2,200.00</strong> per financial year.</li>
            </ul>
          </li>
        </ul>

        <b>Please note that:</b>
        <ul>
          <li>Eligibility is determined at the date the training commences.</li>
          <li>Employees may remain eligible for approved courses commenced within six months of contributions ceasing.</li>
        </ul>

        <div class="header">
          <h3 class="mt-2 mb-0">Eligibility Rules for Group Training Apprentices</h3>
        </div>
        <p>
          Group Training Apprentices registered with CIRT and undertaking an apprenticeship in the electrical
          contracting industry may be eligible for training assistance. This training assistance has been established
          for Group Training Apprentices who do not qualify under the "Employee" category above.
        </p>

          <p>Maximum subsidy: <strong>Up to $600 per financial year.</strong></p>
          <p>This includes eligible Group Training Apprentices who may not have a consistent contribution history due to TAFE attendance, movement between host employers, or placement with non-participating employers.</p>
          <p>Proof of apprenticeship, such as a training contract, will be required.</p>

        <div class="header">
          <h3 class="mt-2 mb-0">How to Apply</h3>
        </div>
        <ol>
          <li>Confirm your course is an approved training course.</li>
          <li>Complete the training.</li>
          <li>Submit your Training Subsidy Application Form.</li>
          <li>Provide supporting documentation: proof of course completion; invoice for the training; proof of payment; and for apprentices, a copy of your training contract.</li>
          <li>Once approved, reimbursement will be paid directly to your nominated bank account.</li>
        </ol>

        <div class="header">
          <h3 class="mt-2 mb-0">Important Information</h3>
        </div>
        <ul>
          <li>Subsidies are only paid upon successful completion of the course.</li>
          <li>Claims must relate to approved training courses.</li>
          <li>Subsidy limits apply per financial year.</li>
          <li>All applications are subject to eligibility verification and approval.</li>
        </ul>
      </div>
    </app-component-wrapper>
  </div>
</div>
